import { useRef } from "react";
import Skeleton from "react-loading-skeleton";
import "./Table.scss";
import EditSvg from "../../assets/img/edit.svg";
import { useComponentVisibles } from "../../utils/functions";

export type ITableButtonOption = {
  onClick?: (index: number) => void | Promise<void>;
  label: string | JSX.Element | boolean;
  colorTheme: "green" | "blue" | "red";
  isLoading?: boolean;
  icon: JSX.Element;
}[];

export interface ITableHome<K = any> {
  title: string;
  titles: {
    label: string;
    isNumeric?: boolean;
    textAlign?: "start" | "center" | "end";
    truncateField?: number;
  }[];
  isLoading?: boolean;
  addLastEmptyTh?: boolean;
  onClickTr?: (index: number) => void;
  setTermFilter?: (string: string) => void;
  data:
    | Record<
        any,
        string | JSX.Element | number | Record<any, any> | boolean | any
      >[];
  dataKeyShow: (keyof K)[];
  addButtonHeader?: {
    onClick: () => void;
    isNumeric?: boolean;
    textAlign?: "start" | "center";
  };
  options?: { booleanToCircle: boolean };
  buttonsOption?: Array<ITableButtonOption>;
}

const Table = <K extends any>({
  titles,
  data,
  options,
  dataKeyShow,
  addButtonHeader,
  addLastEmptyTh = false,
  onClickTr,
  isLoading = false,
  buttonsOption,
}: ITableHome<K>) => {
  /*  const BooleanToCircle = ({ enabled }: { enabled: boolean }) => {
    return (
      <Flex justifyContent={"center"}>
        <Box
          w={5}
          h={5}
          borderRadius={50}
          transition={"background-color 0.3s"}
          bg={enabled ? "green.400" : "red.400"}
        ></Box>
      </Flex>
    );
  }; */

  /*  const truncate = useCallback(
    (field: string, truncateField: number | undefined) =>
      truncateField === undefined ||
      (truncateField && field.length < truncateField) ? (
        field
      ) : (
        <InfoTooltip label={field}>{`${field.substring(
          0,
          truncateField
        )}...`}</InfoTooltip>
      ),
    []
  ); */

  const refs = useRef<(HTMLDivElement | null)[]>([]);
  const handleRefAssignment =
    (index: number) => (ref: HTMLDivElement | null) => {
      refs.current[index] = ref;
    };
  const { isComponentVisible, setComponentVisible } = useComponentVisibles(
    false,
    refs
  );

  const optionsButton = (indexData: number) => {
    const handleOptionClick = (optionIndex: number) => {
      const option = buttonsOption && buttonsOption[indexData][optionIndex];
      if (option && option.onClick) {
        setComponentVisible(indexData);
        option.onClick(indexData);
      }
    };
    return (
      <div
        key={indexData}
        className="table-options-menu"
        ref={handleRefAssignment(indexData)}
      >
        <div className="container-wrapper-options">
          <div
            className="wrapper-options"
            onClick={() => {
              setComponentVisible(indexData);
            }}
          >
            <img src={EditSvg} alt="edit"></img>
          </div>
          <div
            className={`container-options ${
              isComponentVisible[indexData] ? "open" : ""
            }`}
          >
            {buttonsOption![indexData].map(
              ({ label, onClick, colorTheme, icon, isLoading }, index) => (
                <div className="item-options " key={index}>
                  <div
                    key={index}
                    onClick={() => {
                      handleOptionClick(index);
                    }}
                    className={`menu-item menu-item-${colorTheme}`}
                  >
                    <span
                      className={`icon  icon-button-table color-${colorTheme}`}
                    >
                      {icon}
                    </span>
                    <span
                      className={`capitalize-first-letter color-${colorTheme}`}
                    >
                      {label}
                    </span>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      {!isLoading ? (
        <div className="container__table">
          <table className="table">
            <thead className="table__thead">
              <tr>
                {titles.map(({ textAlign, label, isNumeric }, index) => {
                  return (
                    <th
                      key={index}
                      className="text-capitalize th pt-3 pb-2"
                      style={{
                        textAlign: textAlign || "center",
                      }}
                    >
                      {label}
                    </th>
                  );
                })}
                {addLastEmptyTh && (
                  <th
                    style={{
                      width: `${
                        100 / (titles.length + (addButtonHeader ? 1 : 0))
                      }%`,
                    }}
                  ></th>
                )}
                {addButtonHeader && (
                  <th
                    style={{
                      width: `${
                        100 / (titles.length + (addButtonHeader ? 1 : 0))
                      }%`,
                      textAlign: addButtonHeader.textAlign || "end",
                    }}
                  >
                    {/* <AddIcon
                      w={4}
                      h={4}
                      mr={"0.625rem"}
                      cursor={"pointer"}
                      color={"green.500"}
                      onClick={addButtonHeader.onClick}
                    /> */}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {data.map((labels, index) => {
                return (
                  <tr key={index} className="tr">
                    {typeof labels === "object" &&
                      Object.values(labels).map((label, i) => {
                        return (
                          <td
                            onClick={() => {
                              onClickTr && onClickTr(index);
                            }}
                            className="td pointer"
                            style={{
                              width: `${
                                100 /
                                (titles.length + (addButtonHeader ? 1 : 0))
                              }%`,
                              textAlign: titles[i].textAlign || "center",
                            }}
                            key={`${index}${i}`}
                          >
                            <>{label}</>
                          </td>
                        );
                      })}
                    <td
                      className="td"
                      style={{
                        textAlign: "end",
                      }}
                    >
                      {optionsButton(index)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        Array(10)
          .fill(null)
          .map((_, index) => {
            return <Skeleton className="skeleton-table" key={index} />;
          })
      )}
    </>
  );
};

export default Table;
